export const name = 'readPageContent';
export const description = 'Reads the visible text, form inputs, tables, and content of the page the user is currently viewing in the app.';
export const parameters = {};
export const outputTextForUI = 'Aktuális oldal tartalmának olvasása';
export const useOnMobile = false;

export function readPageContent() {
  const currentUrl = window.location.href;
  const currentPath = window.location.pathname;
  const pageTitle = document.title;

  const pageContent = document.querySelector('.page-content');
  const appRoot = document.querySelector('.app') || document.querySelector('#root') || document.body;
  const root = pageContent || appRoot;

  if (!root) {
    return {
      url: currentUrl,
      path: currentPath,
      title: pageTitle,
      content: 'Nem található tartalom az oldalon.'
    };
  }

  function traverse(node: Node): string {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue || '';
      return text.trim() ? text.trim() + ' ' : '';
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }

    const element = node as HTMLElement;

    // Check visibility / display
    try {
      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return '';
      }
    } catch (e) {
      // getComputedStyle might fail if not in document flow
    }

    // Skip scripts, styles, noscript, templates, svgs
    const tagName = element.tagName.toUpperCase();
    if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'SVG', 'HEAD', 'TEMPLATE'].includes(tagName)) {
      return '';
    }

    // Exclude drawers, modals, overlays (like the AI sidebar) to avoid self-scraping
    if (
      element.closest('.mantine-Drawer-root') ||
      element.closest('[class*="Drawer"]') ||
      element.closest('.ai-sidebar') ||
      element.id === 'ai-sidebar' ||
      element.closest('.mantine-Modal-root') ||
      element.closest('[class*="Modal"]')
    ) {
      return '';
    }

    // Capture standard form inputs
    if (tagName === 'INPUT') {
      const inputEl = element as HTMLInputElement;
      if (inputEl.type === 'hidden') return '';
      if (inputEl.type === 'checkbox' || inputEl.type === 'radio') {
        return ` [${inputEl.type.toUpperCase()}: ${inputEl.placeholder || inputEl.name || ''} = ${inputEl.checked ? 'bejelölve' : 'nincs bejelölve'}] `;
      } else {
        return ` [MEZŐ: placeholder="${inputEl.placeholder || ''}" név="${inputEl.name || ''}" érték="${inputEl.value || ''}"] `;
      }
    }

    if (tagName === 'TEXTAREA') {
      const textareaEl = element as HTMLTextAreaElement;
      return ` [TEXTAREA: placeholder="${textareaEl.placeholder || ''}" név="${textareaEl.name || ''}" érték="${textareaEl.value || ''}"] `;
    }

    if (tagName === 'SELECT') {
      const selectEl = element as HTMLSelectElement;
      const selectedOption = selectEl.options[selectEl.selectedIndex];
      const valText = selectedOption ? selectedOption.textContent : selectEl.value;
      return ` [LEGÖRDÜLŐ: név="${selectEl.name || ''}" érték="${valText || ''}"] `;
    }

    if (tagName === 'TABLE') {
      const rows = Array.from(element.querySelectorAll('tr'));
      const tableLines = rows.map(row => {
        const cells = Array.from(row.querySelectorAll('th, td'));
        return '| ' + cells.map(cell => {
          return Array.from(cell.childNodes).map(traverse).join('').trim().replace(/\s+/g, ' ');
        }).join(' | ') + ' |';
      });
      return '\n' + tableLines.join('\n') + '\n';
    }

    // Recurse into children
    let childText = '';
    const childNodes = Array.from(element.childNodes);
    for (const child of childNodes) {
      childText += traverse(child);
    }

    // Formatting blocks
    if (['DIV', 'P', 'LI', 'TR', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'MAIN', 'SECTION', 'ARTICLE'].includes(tagName)) {
      return `\n${childText}\n`;
    }

    return childText;
  }

  let rawContent = traverse(root);

  // Clean up formatting
  rawContent = rawContent
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]+/g, ' ')               // Collapse horizontal spaces
    .replace(/\n\s*\n\s*\n+/g, '\n\n')       // Max 2 consecutive newlines
    .trim();

  return {
    url: currentUrl,
    path: currentPath,
    title: pageTitle,
    content: rawContent || 'Az oldal üres vagy nem tartalmaz olvasható szöveget.'
  };
}
